"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url_parse_1 = __importDefault(require("url-parse"));

var client_library_1 = require("@seneca/client-library");

var consts_1 = require("../consts");

var constructTransformersString_1 = __importDefault(require("./constructTransformersString"));

function getCdnUrl(imageUrl) {
  var parsedUrl = new url_parse_1["default"](imageUrl);
  parsedUrl.set('protocol', consts_1.CDN_URL_PROTOCOL);
  parsedUrl.set('slashes', '//');
  parsedUrl.set('hostname', '');
  parsedUrl.set('port', undefined);
  return parsedUrl.toString();
}

exports.getCdnUrl = getCdnUrl;

function parseCdnUrl(url, baseUrl, options) {
  var parsedBaseUrl = new url_parse_1["default"](baseUrl);
  var parsedUrl = new url_parse_1["default"](url);
  parsedUrl.set('protocol', parsedBaseUrl.protocol);
  parsedUrl.set('hostname', parsedBaseUrl.hostname);
  parsedUrl.set('port', parsedBaseUrl.port);
  var paramStr = constructTransformersString_1["default"](options);

  if (paramStr && paramStr.length) {
    var parsedPathname = /^(.*)\.(.*)$/.exec(parsedUrl.pathname);

    if (!parsedPathname || parsedPathname.length < 3) {
      throw new client_library_1.InvalidParamError('baseUrl', baseUrl, 'Could not parse path and extension from url');
    }

    var _parsedPathname = _slicedToArray(parsedPathname, 3),
        _ = _parsedPathname[0],
        path = _parsedPathname[1],
        ext = _parsedPathname[2];

    parsedUrl.set('pathname', "".concat(path, ",").concat(paramStr, ".").concat(ext));
  }

  return parsedUrl.toString();
}

exports.parseCdnUrl = parseCdnUrl;